import { type DocASTNode, SolidStreamingMarkdown } from "@storytell/markdown";

export const StreamingMarkdownSmall = (props: { doc: DocASTNode }) => {
  return (
    <div class="text-sm max-w-none">
      <SolidStreamingMarkdown
        doc={props.doc}
        options={{
          classes: {
            document: "wrap-break-word whitespace-break-spaces [&_*:last-child]:mb-0",
            heading: (node) => {
              switch (node.level) {
                case 1:
                  return "font-medium text-lg mb-2 mt-3";
                case 2:
                  return "font-medium text-base mb-2 mt-3";
                case 3:
                  return "font-medium text-sm mb-2 mt-3";
                default:
                  return "font-medium text-sm mb-2 mt-3";
              }
            },
            paragraph: "mb-2",
            list: (node) => {
              switch (node.listData?.type) {
                case "ordered":
                  return "list-decimal pl-4 mb-2";
                case "bullet":
                  return "list-disc pl-4 mb-2";
                default:
                  return "";
              }
            },
            item: "mb-1",
            code: "bg-black/10 dark:bg-white/10 px-0.5 py-0.5 rounded text-xs",
            blockQuote: "border-l-2 border-blue-100 dark:border-blue-700 pl-2 py-1 my-1",
            link: "font-medium text-primary-text underline underline-offset-2",
          },
        }}
      />
    </div>
  );
};
